import { DEFAULT_FILTER } from './user';
import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from 'Src/consts/table';

/** USER TAG TABLE */
export function getVenues(user: AppUser, filter = DEFAULT_FILTER) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter
    }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/places`, config).then(response => {
    return response.data;
  });
}

export function getAllVenues(user: AppUser, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/places`, config).then(response => {
    return response.data;
  });
}

export function getVenuesCount(user: AppUser, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;
  const config = {
    headers: { usid: key },
    params: { filter: { where: where || {} } }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/places/count`, config)
    .then(response => response.data);
}

export function createVenue(user: AppUser, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.post(`${window.apiBase}/i/schools/${activeSchoolId}/places`, data, config).then(response => {
    return response.data;
  });
}

export function updateVenue(user: AppUser, data, placeId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.put(`${window.apiBase}/i/schools/${activeSchoolId}/places/${placeId}`, data, config).then(response => {
    return response.data;
  });
}

export function deleteVenue(user: AppUser, placeId) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.delete(`${window.apiBase}/i/schools/${activeSchoolId}/places/${placeId}`, config).then(response => {
    return response.data;
  });
}
